import { EsquireClient } from "@/types/clients/esquire";


interface ContractStatusResponse {
  contract_status: string;
}

export default class GetContractStatus {
  constructor(private client: EsquireClient) {}

  public async send(): Promise<string> {
    const url = await this.client.fetchUrlFromSession("contract-status");
    const response = await this.client.fetch(
      () => new URL(url), {
        method: "GET"
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      return "";
    }
    const result = await response.json() as ContractStatusResponse;
    return result.contract_status;
  }
}
